import React from "react";

const Hairline: React.FC = () => <div className="h-px bg-[#EBEBEB]" />;

export default Hairline;
